<template>
  <a-alert type="info" closable v-if="demo_alert">
    <span slot="message">
      我们精心制作了当前界面的快速上手视频教程
      <a @click="demoSetVideo(name)">
        <a-icon type="video-camera" :style="{margin:'0px 5px'}" />点击查看
      </a>
    </span>
  </a-alert>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'DemoVideoAlert',
  components: {},
  data() {
    return {}
  },
  props: {
      name: String
  },
  computed: {
    demo_alert() {
      return this.$store.state.brand.demo_alert
    }
  },
  created() {},
  mounted() {},
  filters: {},
  methods: {
    ...mapActions(['demoSetVideo'])
  }
}
</script>

<style lang="less" scoped>
</style>
